export default "__VITE_ASSET__BxQq1fD3__"